export enum VTREE_TRIGGER {
  CLICK = 'click',
  REF = 'ref',
}
